import { InfoBarMessageViewState } from '../schema/InfoBarMessageViewState';

export default function isLocalizedInfoBarMessage(viewState: InfoBarMessageViewState): boolean {
    return !!viewState.localizedMessageTemplateString;
}
